import { render, staticRenderFns } from "./Citizens.vue?vue&type=template&id=073916fa&scoped=true"
import script from "./Citizens.vue?vue&type=script&lang=js"
export * from "./Citizens.vue?vue&type=script&lang=js"
import style0 from "./Citizens.vue?vue&type=style&index=0&id=073916fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073916fa",
  null
  
)

export default component.exports